import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import Button from '../core/button/CoreButton';
import PageBannerCard from '../core/card/PageBannerCard';
import ActivateLicenseMinorCTA from './ActivateLicenseMinorCTA';

export interface ILicenseExpiredBannerCardProps {
    canManageBilling: boolean;
    organizationId: string;
    isManagedOrg?: boolean;
    customBillingUrl?: string;
}

export default function LicenseExpiredBannerCard({
    canManageBilling,
    organizationId,
    isManagedOrg,
    customBillingUrl,
}: ILicenseExpiredBannerCardProps) {
    const { t } = useTranslation();
    const { managedOrgId } = useParams();

    // show billing link if: not a managed org, or is a managed org with custom billing but not viewed by a reseller admin
    const showBillingLink = !isManagedOrg || (!managedOrgId && !!customBillingUrl);

    return (
        <PageBannerCard
            icon="cancel"
            fullHeight
            title={t('common:organization.expired.title')}
            description={
                canManageBilling ? t('common:organization.expired.admin') : t('common:organization.expired.user')
            }>
            {canManageBilling && (
                <>
                    {showBillingLink && (
                        <Button href={`#/org/${organizationId}/billing/redirect/upgrade`} endIcon="externalLink">
                            {t('common:billing.view')}
                        </Button>
                    )}
                    <ActivateLicenseMinorCTA organizationId={organizationId} />
                </>
            )}
        </PageBannerCard>
    );
}
